import appConfigLogic from "./app-config-logic/appConfigLogic";
import authLogic from "./auth-logic/authLogic";
import controlPanelLogic from "./control-panel-logic/controlPanelLogic";
import experiencesLogic from "./experiences-logic/experiencesLogic";
import appsLogic from "./apps-logic/appsLogic";
import userLogic from "./user-logic/userLogic";
import themesLogic from "./themes-logic/themesLogic";
import pagesLogic from "./pages-logic/pagesLogic";
import postsLogic from "./posts-logic/postsLogic";
import modulesLogic from "./modules-logic/loadModulesLogic";
import culturesLogic from "./lookups-logic/culturesLogic";
import topicsLogic from "./topics-logic";
import globalLogic from "./global-logic";
import sessionsLogic from "./sessions-logic/sessionsLogic";
import notificationsLogic from "./notifications-logic/notificationsLogic";
import integrationsLogic from "./integrations-logic/integrationsLogic";
import oauthLogic from "./oauth-logic";

// Add Data Provider here
export default [
	...appConfigLogic,
	...authLogic,
	...controlPanelLogic,
	...appsLogic,
	...experiencesLogic,
	...userLogic,
	...themesLogic,
	...pagesLogic,
	...modulesLogic,
	...culturesLogic,
	...topicsLogic,
	...globalLogic,
	...postsLogic,
	...sessionsLogic,
	...notificationsLogic,
	...integrationsLogic,
	...oauthLogic,
];
